import { useMutation } from "redux-query-react";
import { deletePortfolios } from "api/ux/src";
const updateForDelete = (ids) => ({
    Portfolio: (prevValue) => {
        const updateValue = { ...prevValue };
        ids.forEach((id) => {
            delete updateValue[id];
        });
        return updateValue;
    },
    PortfolioVersions: (prevValue) => {
        const updateValue = { ...prevValue };
        ids.forEach((id) => {
            delete updateValue[id];
        });
        return updateValue;
    },
    Portfolios: (prevValue) => {
        const updateValue = { ...prevValue };
        ids.forEach((id) => {
            delete updateValue[id];
        });
        return updateValue;
    }
});
const optimisticUpdateForDelete = (ids) => ({
    Portfolio: (prevValue) => {
        const optimisticValue = { ...prevValue };
        ids.forEach((id) => {
            delete optimisticValue[id];
        });
        return optimisticValue;
    },
    PortfolioVersions: (prevValue) => {
        const optimisticValue = { ...prevValue };
        ids.forEach((id) => {
            delete optimisticValue[id];
        });
        return optimisticValue;
    },
    Portfolios: (prevValue) => {
        const optimisticValue = { ...prevValue };
        ids.forEach((id) => {
            delete optimisticValue[id];
        });
        return optimisticValue;
    }
});
const rollbackForDelete = (ids) => ({
    Portfolio: (initialValue, currentValue) => {
        const rollbackValue = { ...currentValue };
        ids.forEach((id) => {
            rollbackValue[id] = initialValue[id];
        });
        return rollbackValue;
    },
    PortfolioVersions: (initialValue, currentValue) => {
        const rollbackValue = { ...currentValue };
        ids.forEach((id) => {
            rollbackValue[id] = initialValue[id];
        });
        return rollbackValue;
    },
    Portfolios: (initialValue, currentValue) => {
        const rollbackValue = { ...currentValue };
        ids.forEach((id) => {
            rollbackValue[id] = initialValue[id];
        });
        return rollbackValue;
    }
});
export const useDeletePortfolios = (customQueryConfig) => useMutation((request, customQueryParam) => {
    const customQueryConfig1 = { optimisticUpdate: optimisticUpdateForDelete(request?.deletePortfolioRequest?.portfolioIds ?? []),
        rollback: rollbackForDelete(request?.deletePortfolioRequest?.portfolioIds ?? []),
        update: updateForDelete(request?.deletePortfolioRequest?.portfolioIds ?? []) };
    return deletePortfolios(request, { ...customQueryConfig1, meta: { ...customQueryConfig?.meta, ...customQueryParam } });
});
